<template>
	<div>
		<case-form :schema="schema" />
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"

export default {
	name: "JBProposalMaterialFacts",
	components: { CaseForm },
	data() {
		return {
			schema: [
				{
					label:
						"25. Are there any other circumstances within your knowledge or opinion not already disclosed, affecting or likely to affect the proposed insurance?",
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: "case.facts.holderOtherMaterialFactsId",
					props: {
						suggest: {
							typeIncludes: "otherMaterialFacts"
						},
						createOptions: {
							type: "otherMaterialFacts",
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
